import { useEffect, useState, useRef } from 'react';
import BOLayout from '@/pages/back-office/BOLayout';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import SettingsTopBanner from '@/components/back-office/SettingsTopBanner';

const CategoryCreation = () => {
	const [canSubmit, setCanSubmit] = useState(false);
	const [name, setName] = useState('');
	const [picture, setPicture] = useState(null);
	const [preview, setPreview] = useState(null);
	const pictureRef = useRef(null);
	const navigate = useNavigate();
	const role = JSON.parse(localStorage.getItem('role'));

	useEffect(() => {
		if (role && role !== 'super-admin') {
			toast.info('Zone interdite', {
				position: 'top-center',
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				theme: 'colored',
			});

			navigate('/back-office');

			return;
		}
	}, [role]);

	useEffect(() => {
		if (name) {
			setCanSubmit(true);
			return;
		}

		setCanSubmit(false);
	}, [name]);

	const handlePicture = (e) => {
		const file = e.target.files[0];
		if (file) {
			setPicture(file);
			const reader = new FileReader();
			reader.onloadend = () => {
				setPreview(reader.result);
			};
			reader.readAsDataURL(file);
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		const formData = new FormData();
		formData.append('name', name);
		if (picture) {
			formData.append('picture', picture);
		}

		try {
			const response = await axios.post(
				`${import.meta.env.VITE_API_URL}/api/back-office/settings/categories/create`,
				formData,
				{
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				}
			);

			if (response.status === 201) {
				toast.success('Catégorie créée avec succès', {
					position: 'top-center',
					autoClose: 800,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: true,
					theme: 'colored',
				});
			}
		} catch (error) {
			console.error('Error creating category:', error);

			toast.error('Une erreur est survenue', {
				position: 'top-center',
				autoClose: 800,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				theme: 'colored',
			});
		}

		setTimeout(() => {
			navigate('/back-office/settings/categories/list');
		}, 1000);
	};

	return (
		<BOLayout>
			<div className="mb-12 grid grid-cols-1 gap-12">
				<SettingsTopBanner />
				<h1 className="text-3xl font-bold text-center">Ajoutez une catégorie</h1>
			</div>

			<form className="text-center">
				{preview && (
					<img 
						src={preview} 
						alt="Aperçu" 
						className="mb-4 mx-auto border border-black p-2 rounded-lg w-[150px] h-[150px] object-cover"
					/>
				)}

				<div
					className="mb-4 mx-auto flex items-center border border-black p-2 rounded-lg w-1/4 text-sm hover:cursor-pointer"
					onClick={() => pictureRef.current.click()}
				>
					<input 
						type="file" 
						accept="image/*"
						name="picture" 
						id="picture" 
						className="hidden" 
						ref={pictureRef} 
						onChange={handlePicture} 
					/>
					<img src="/src/assets/media/pictures/import.png" alt="" width={30} className="mr-2" />
					<label className="hover:cursor-pointer">Téléchargez l'image de votre catégorie</label>
				</div>

				<div className="xl:flex justify-center items-center gap-2">
					<div className="flex flex-col">
						<label htmlFor="name" className="text-left pl-2">
							Nom
						</label>
						<input
							type="text"
							name="name"
							id="name"
							className="mb-4 border border-black p-2 rounded-lg"
							onChange={(e) => setName(e.target.value)}
						/>
					</div>
				</div>

				<button
					type="submit"
					onClick={handleSubmit}
					className={`transition duration-300 text-white px-4 py-2 rounded-lg ${
						canSubmit
							? 'bg-primary hover:bg-primary/80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary/70'
							: 'bg-gray-400 cursor-not-allowed'
					}`}
					disabled={!canSubmit}
				>
					Créer la catégorie
				</button>
			</form>
		</BOLayout>
	);
};

export default CategoryCreation;
